import { defineStore } from "pinia"
import { useCameraStore } from "@evercam/dashboard/stores/camera"
import {
  PROJECT_ROLES,
  CAMERA_ROLES,
} from "@evercam/dashboard/constants/mockRoles"

export const useAuthorizationStore = defineStore("authorization", {
  state: () => ({
    companyRoles: null,
    projectRoles: new Map(),
    cameraRoles: new Map(),
  }),

  actions: {
    fetchCompanyRoles() {},
    async fetchProjectRole(projectExid: string) {
      if (this.projectRoles.has(projectExid)) return

      const cameraStore = useCameraStore()
      const cameras = cameraStore.getCamerasByProjectExid(projectExid)
      const assignedProjectRoleKey = "collaborator" // mock assignment
      const assignedProjectRole = PROJECT_ROLES[assignedProjectRoleKey]
      this.projectRoles.set(projectExid, {
        ...assignedProjectRole,
        value: assignedProjectRoleKey,
      })
      const assignedCameraRoleKey = "view_only"
      const assignedCameraRole = CAMERA_ROLES[assignedCameraRoleKey]

      const camMap = new Map()
      for (const cam of cameras) {
        camMap.set(cam.exid, {
          ...assignedCameraRole,
          value: assignedCameraRoleKey,
          cameraExid: cam.exid,
        })
      }

      this.cameraRoles.set(projectExid, camMap)
    },

    clearRoles() {
      this.projectRoles.clear()
      this.cameraRoles.clear()
    },
  },

  getters: {
    getAssignedProjectRole: (state) => (projectExid: string) =>
      state.projectRoles.get(projectExid),
    getCameraRole: (state) => (projectExid: string, cameraExid: string) =>
      state.cameraRoles.get(projectExid)?.get(cameraExid),
    getAvailableProjectRoles: () =>
      function (projectExid: string, cameras: { exid: string }[] = []) {
        return Object.entries(PROJECT_ROLES).map(([key, def]) => {
          const accessLevel = def.cameraAccessLevel || "full_access"

          return {
            text: def.text,
            value: key,
            width: 100,
            permissions: def.permissions.map((p) => p.value),
            cameraAccess: cameras.map((camera) => ({
              cameraExid: camera.exid,
              accessLevel,
            })),
          }
        })
      },
    getAvailableCameraRoles: () => Object.values(CAMERA_ROLES),
  },
})
